import { BaseModel } from '../classes/base-model';

export class Sponsor extends BaseModel{
	Id: number;
  	Name: string;
}


// WEBPACK FOOTER //
// ./src/app/models/sponsor.ts